<template>
  <c-loading-area v-if="!isLocked" :loading="loading" :height="50" :card="false">
    <!-- horizontal (monitor) display -->
    <v-tabs :value="selectedStepIndex"
            @change="changeTab"
            slider-color="accent"
            slider-size="4"
            class="elevation-2 d-none d-md-block d-print-none rounded"
            grow>
      <v-tab v-for="(step, i) in filingSteps" class="primary--text inset-focus" tag="button" :key="step.filingStepID"
             :disabled="!step.available" @click="refreshTab(i)">
        <div v-if="step.available && isComplete(step)" class="mr-2 primary white--text rounded-circle d-flex align-center"
             style="width:1.8em;height:1.8em;line-height:1em;letter-spacing:0">
          <div class="flex-grow-1 text-center">
            <v-icon small color="white">
              mdi-check-bold
            </v-icon>
          </div>
        </div>
        <div v-else class="mr-2 primary white--text rounded-circle d-flex align-center"
             style="width:1.8em;height:1.8em;line-height:1em;letter-spacing:0">
          <div class="flex-grow-1 text-center">{{ i + 1 }}</div>
        </div>
        {{ step.name }}
      </v-tab>
    </v-tabs>

    <!-- vertical (mobile) display -->
    <v-tabs :value="selectedStepIndex"
            @change="changeTab"
            slider-color="accent"
            slider-size="4"
            class="elevation-2 mb-5 d-md-none d-print-none rounded"
            vertical>
      <v-tab v-for="(step, i) in filingSteps" class="primary--text inset-focus justify-start" tag="button" style="max-width:none"
             :key="step.filingStepID" :disabled="!step.available" @click="refreshTab(i)">
        <div v-if="step.available && isComplete(step)" class="mr-2 primary py-1 px-1 white--text rounded-circle">
          <v-icon small color="white">
            mdi-check-bold
          </v-icon>
        </div>
        <div v-else class="mr-2 primary py-1 px-2 white--text rounded-circle">
          {{ i + 1 }}
        </div>
        {{ step.name }}
      </v-tab>
    </v-tabs>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  computed: {
    loading () {
      return _.isEmpty(this.filingSteps);
    },
    filingSteps () {
      return filingStore.filingSteps;
    },
    selectedStepIndex () {
      return filingStore.selectedStepIndex;
    },
    isLocked () {
      return filingStore.isLocked;
    }
  },
  methods: {
    changeTab (newIndex) {
      filingStore.$patch({ selectedStepIndex: newIndex });
    },
    isComplete (step) {
      return filingStore.isStepComplete(step.filingStepID);
    },
    refreshTab (index) {
      if (index === this.selectedStepIndex)
      {
        filingStore.refreshTab();
      }
    }
  }
};
</script>